<ion-spinner [name]="config.name" [color]="config.color">
</ion-spinner>